import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=0c8900de&scoped=true"
import script from "./courseItem.vue?vue&type=script&lang=js"
export * from "./courseItem.vue?vue&type=script&lang=js"
import style0 from "./courseItem.vue?vue&type=style&index=0&id=0c8900de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8900de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8900de')) {
      api.createRecord('0c8900de', component.options)
    } else {
      api.reload('0c8900de', component.options)
    }
    module.hot.accept("./courseItem.vue?vue&type=template&id=0c8900de&scoped=true", function () {
      api.rerender('0c8900de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/courseItem.vue"
export default component.exports